<!--
 * @Description: 个体自然人完税证明
 * @Date: 2023-02-24 14:02:57
-->
<template>
  <table-render
    ref="tableRender"
    :config="config"
    :propDate="propData"
    style="padding:20px 10px;margin-top:0;height: initial;"
  ></table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import { taxPayment } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';
import createExtend from '@C/createExtend';
import PaymentDetail from './PaymentDetail';
let receiveDtEnd = new Date();
let receiveDtStart = new Date();
receiveDtStart.setMonth(receiveDtStart.getMonth() - 12);
receiveDtStart = dateFormat(receiveDtStart, 'YYYY-MM-DD');
receiveDtEnd = dateFormat(receiveDtEnd, 'YYYY-MM-DD');

const individualNameSerch = {
  id: 'entIdentifierName',
  label: '个体名称',
  tip: '请输入个体名称',
  key: 'entIdentifierName',
  maxLength: 30,
  slot: 'input',
  clearable: true
};
const entIdentifierName = {
  label: '个体名称',
  prop: 'entIdentifierName'
};
const feeProjectName = {
  label: '征收项目',
  prop: 'feeProjectName'
};
const feeItemName = {
  label: '征收品目',
  prop: 'feeItemName'
};
const feeStatus = {
  label: '缴费状态',
  prop: 'feeStatus',
  formatter: (r, c, v) => {
    return { 0: '未缴费', 1: '已缴费' }[v];
  }
};
const operate = {
  label: '操作',
  render: (h, ctx, row) => {
    const showModal = () => {
      createExtend(PaymentDetail, { row }).$on('refresh', () => {
        ctx.parent.$message.success('操作成功');
        ctx.parent.getPageList(1);
      });
    };
    const download = () => {
      taxPayment.personAlityListDownLoad({ proofId: row.proofId }).then(res => {
        ctx.parent.$message.success(res.pdata);
      });
    };
    return (
      <div>
        <el-button
          onClick={() => {
            showModal();
          }}
          type="text"
        >
          查看
        </el-button>
        <el-button
          onClick={() => {
            download();
          }}
          type="text"
        >
          下载
        </el-button>
      </div>
    );
  }
};
export default {
  components: { tableRender },
  data() {
    return {};
  },
  methods: {},
  computed: {
    config() {
      const allDownLoad = {
        name: '批量下载',
        type: 'primary',
        fn: (app, table) => {
          taxPayment.personAlityListDownLoad(table.searchQuery).then(res => {
            this.$message.success(res.pdata);
          });
        }
      };
      return [
        {
          name: '个体自然人完税证明',
          childMenu: [
            {
              name: '1',
              list: taxPayment.personAlityList,
              moreBtnArr: [allDownLoad],
              search: [
                individualNameSerch,
                {
                  id: 'authTimeRange',
                  label: '接收时间',
                  tip: '时间区间',
                  required: false,
                  key: ['receiveDtStart', 'receiveDtEnd'],
                  slot: 'daterange',
                  clearable: false,
                  timeHander: val => {
                    let [startDt, endDt] = val;
                    // 起始时间一年后
                    const startDtOneYearlater = new Date(startDt);
                    startDtOneYearlater.setFullYear(
                      new Date(startDt).getFullYear() + 1
                    );
                    if (
                      new Date(endDt).getTime() > startDtOneYearlater.getTime()
                    ) {
                      this.$message({
                        message: '日期选择范围：最大只能选择一年',
                        type: 'warning'
                      });
                      endDt = dateFormat(startDtOneYearlater, 'YYYY-MM-DD');
                    }
                    return [startDt, endDt];
                  },
                  val: [receiveDtStart, receiveDtEnd]
                }
              ],
              fields: [
                { type: 'index', width: '58px' },
                entIdentifierName,
                feeProjectName,
                feeItemName,
                feeStatus,
                {
                  label: '接收时间',
                  prop: 'receiveDt',
                  formatter: (r, c, v) => dateFormat(v, 'YYYY-MM-DD') || '-'
                },
                operate
              ]
            }
          ]
        }
      ];
    },
    propData() {
      const param = { receiveDtStart, receiveDtEnd };
      return {
        query: param
      };
    }
  }
};
</script>
<style lang="scss" scoped>
>>> .el-dialog__footer,
.el-pagination {
  text-align: center;
}
</style>
